import { __generator } from "tslib";
import React from 'react';
import { put } from 'redux-saga/effects';
import { Warning } from '../../Icons/Confirmations';
import { pushGlobalConfirmationModalForMM } from '../../Modals/redux/actionCreators';
import { canMakeDeviationPremium } from '../helpers';
export function checkAndWarnIfDeviationsAreNotSupportedForPremium(deviations) {
    var hasUnsupportedDeviationSelected;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                hasUnsupportedDeviationSelected = deviations.some(function (deviation) { return !canMakeDeviationPremium(deviation); });
                if (!hasUnsupportedDeviationSelected) return [3 /*break*/, 2];
                return [4 /*yield*/, put(pushGlobalConfirmationModalForMM({
                        titleTransKey: 'mediapopup.warningPopup.deviationNotSupportedForPremium.title',
                        textTransKey: 'mediapopup.warningPopup.deviationNotSupportedForPremium.text',
                        confirmBtnLabelTransKey: 'common.ok',
                        withCancelButton: false,
                        confirmBtnType: 'dark',
                        icon: React.createElement(Warning, null),
                    }))];
            case 1:
                _a.sent();
                return [2 /*return*/, true];
            case 2: return [2 /*return*/, false];
        }
    });
}
//# sourceMappingURL=helpers.js.map